var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1BA27A",
    d: "M24 12c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.373 5.373 0 12 0c6.628 0 12 5.373 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.63 6.051H6.266v2.743h4.31v4.032h2.743V8.794h4.31V6.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.973 13.256c-3.565 0-6.455-.564-6.455-1.26 0-.696 2.89-1.26 6.455-1.26 3.566 0 6.456.564 6.456 1.26 0 .696-2.89 1.26-6.456 1.26Zm7.249-1.05c0-.898-3.245-1.625-7.249-1.625-4.003 0-7.248.727-7.248 1.625 0 .79 2.516 1.449 5.85 1.595v5.788h2.744v-5.786c3.36-.141 5.903-.803 5.903-1.597Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.abef65096c6d4241f69938dbb5c69125.svg";
export { ForwardRef as ReactComponent };